import {useAsync} from "react-async";
import {useContext} from "react";
import {ClientBridge} from "../index";
import {each, now, keys} from "lodash";
import {isBlank} from "../lib/Utils";


export function useMccSearch(queryInfo){

    const {mcc, mccLogin, wizard} = useContext(ClientBridge);

    return useAsync({
        promiseFn: mccSearch,
        watch: queryInfo,
        queryInfo,
        mcc,
        mccLogin,
        wizard
    });
}

// todo - ?just create single Search & refresh query
export async function mccSearch({mcc, mccLogin, queryInfo, wizard})
{
    const mccQuery = getMccQuery({mcc, mccLogin, queryInfo, wizard});
    const search = new mcc.Search('aod_wizard_1',mccQuery);
    const {pager: {start, batchSize, order}={}} = queryInfo;

    return search.execute(start, batchSize, order)
        .then(results=>{
            results.records.forEach( rec => {
                rec.previewUrl = rec.getPreviewUrl();
                rec.thumbUrl = rec.getThumbUrl();
            });
            results.id = now();
            results.textQuery = mccQuery.asText();
            // status?
            return results;
        });
        // failed?
}


function getMccQuery({mcc, mccLogin, queryInfo, wizard})
{
    var query = new mcc.Query();
    const {search={}, filters={},  notFilters={}} = queryInfo;

    each(filters, (value,key)=>{
        if (key === 'medium') {

            const medium = (value && value.length && value[0]) || ''
            const allWebAdSizes = keys(mcc.values.web_ad_size) ;
            const searchWebAdSizes = isBlank(filters.web_ad_size) ? allWebAdSizes : filters.web_ad_size;

            if ( medium.startsWith('print') )
            {
                //query.addFilter('file_ext','qxd@qxp');
                if ( medium === 'printwithweb') {
                    query.addFilter('extra','web ad');
                } else {
                    query.addNotFilter('web_ad_size', allWebAdSizes)
                }
            }
            else if (medium==='web')  // web only
            {
                //query.addFilter('file_ext','psd@jpg');
                query.addFilter('web_ad_size',searchWebAdSizes)
            }

        } else {
            query.addFilter(key,value);
        }
    });
    each(notFilters, (value,key)=>{
        if (! (key in filters)) {
            query.addNotFilter(key, value);
        }
    });
    each(search, (value,key)=>{
        query.addSearch(key,value);
    });

    if (!('service' in filters)) {
        const services = wizard.getServices();
        query.addFilter('service', services);
        //query.addFilter('service', mccLogin.standardServices);
    }

    return query;
}
